import { BasicQueryState } from './basic-queries/BasicQueriesTypes'
import { TaxCouponState } from './tax-coupon/TaxCouponTypes'
import { StockAddressingInBatchState } from './stock-addressing-in-batch/StockAddressingInBatchTypes'
import { StockAdjustmentInBatchState } from './stock-adjustment-in-batch/StockAdjustmentInBatchTypes'
import { StockListState } from './stock-list/StockListTypes'
import { StockManagementState } from './stock-management/StockManagementTypes'
import { StockMovementsState } from './stock-movements/StockMovementsTypes'
import { ReceivementState } from './receivement/ReceivementTypes'
import { FractionState } from './fraction/FractionTypes'
import { DanfeState } from 'src/components/Danfe/danfeTypes'
import { PendingReceivementsState } from './pending-receivements/PendingReceivementsTypes'
import { SupplierState } from './supplier/SupplierTypes'
import { ReceivementOverviewListState } from './receivement-overview-list/ReceivementOverviewListTypes'
import { DockManagementState } from './dock-management/DockManagementTypes'
import { RestockingState } from './restocking/RestockingTypes'
import { InventoryState } from './inventory/InventoryTypes'
import { ShedManagementState } from './shed-management/ShedManagementTypes'
import { SwapOrReturnState } from './swap-or-return/SwapOrReturnTypes'
import { PrintersManagementState } from './settings/printers-management/PrintersManagementTypes'
import { TransfersState } from './transfers/TransfersTypes'
import { DivergenceDemandsState } from './divergence-demands/DivergenceDemandsTypes'

export type Await<T> = T extends Promise<infer R> ? R : T

export type ReturnCall<T extends (...args: any) => any> = Await<ReturnType<T>>

export interface ApiError {
  error_code: string
  message: string
  status_code: number
  validation_errors?: {
    [key: string]: string[]
  }
}

export interface State {
  app: AppState
  stockList: StockListState
  stockManagement: StockManagementState
  stockMovements: StockMovementsState
  stockAddressingInBatch: StockAddressingInBatchState
  stockAdjustmentInBatch: StockAdjustmentInBatchState
  taxCoupon: TaxCouponState
  receivement: ReceivementState
  fraction: FractionState
  danfe: DanfeState
  pendingReceivements: PendingReceivementsState
  supplier: SupplierState
  receivementOverviewList: ReceivementOverviewListState
  basicQuery: BasicQueryState
  dockManagement: DockManagementState
  restocking: RestockingState
  divergenceDemands: DivergenceDemandsState
  inventory: InventoryState
  shedManagement: ShedManagementState
  swapOrReturn: SwapOrReturnState
  printersManagement: PrintersManagementState
  transfers: TransfersState
}

export interface FulfillmentCenter {
  id: number,
  name: string
  type?: string
}

export enum FulfillmentCenterType {
  FC = 'FC',
  MARKET_STORE = 'MARKET_STORE',
  DARK_STORE = 'DARK_STORE',
}

export type FulfillmentCenterTypeFilters = Partial<Record<FulfillmentCenterType, boolean>>

export type FulfillmentCentersStatus = 'idle' | 'loading' | 'succeeded' | 'failed'

export interface Dock {
  id: number,
  code: string,
  defaultLocationId: number,
  isFresh: boolean,
  fulfillmentCenterId: number
}

export interface AppState {
  isLoading: boolean,
  token?: string,
  userBadge?: boolean,
  userBarcode?: string,
  fulfillmentCenters: FulfillmentCenter[],
  fulfillmentCentersFilters?: FulfillmentCenterTypeFilters,
  fulfillmentCentersStatus?: FulfillmentCentersStatus,
  assignedDock?: Dock
}

export interface Product {
  stockId: number,
  modelId: number,
  code: string,
  barcodes: string,
  description: string,
  category: string,
  total: number,
  reserved: number,
  available: number,
  fulfillmentCenter: {
    id: number,
    name: string
  }
  reservedQuantityOrders: number,
  reservedQuantityReturn: number,
  reservedQuantitySwap: number,
  reservedQuantityTransfers: number,
  reservedQuantityNfd: number,
}

export interface Movement {
  createdAt: Date,
  fulfillmentCenter: {
    id: number,
    name: string,
  },
  type: string,
  product: {
    modelId: number,
    code: string,
    description: string,
  },
  user: string,
  appliedQuantity: number,
  balance: number,
  orderCode: string,
  invoiceKey: string,
  receivementId: number,
}

export interface GetStockMovements {
  fulfillmentCenterId?: number,
  modelId?: number,
  startDate?: Date | null,
  endDate?: Date | null,
  description?: string,
  type?: string,
  sourceSystem?: string,
  page: number,
  pageSize: number,
  code?: string,
  user?: string,
}

export enum AvariaEnum {
  NENHUM = 'NENHUM',
  VALIDADE = 'VALIDADE',
  DANO = 'DANO',
}
